import Disclaimer from "../Disclaimer";
import Hero from "../Hero";
import Intro from "../Intro";
import Media from "../Media";
import Video from "../Video";
import CTAComponent from "../CTAComponent";
var components = new Map([
    ["ctaComponent", CTAComponent],
    ["CtaComponent", CTAComponent],
    ["hero", Hero],
    ["Hero", Hero],
    ["intro", Intro],
    ["Intro", Intro],
    ["fullWidthVideo", Video],
    ["FullWidthVideo", Video],
    ["mediaSlide", Media],
    ["MediaSlide", Media],
    ["disclaimer", Disclaimer],
    ["Disclaimer", Disclaimer],
]);
export default components;
